import { Box, styled } from '@mui/material';

export const SnapshotIndicator = (props: {
  backgroundColor: string | null;
  isPartial?: boolean;
  isPitr?: boolean;
  sx?: object;
}) => {
  return props.isPartial ? (
    <PartialSnapshotIndicator
      backgroundColor={props.backgroundColor}
      sx={props.sx}
    />
  ) : props.isPitr ? (
    <PitrSnapshotIndicator fill={props.backgroundColor} />
  ) : (
    <FullSnapshotIndicator
      backgroundColor={props.backgroundColor}
      sx={props.sx}
    />
  );
};

const PitrSnapshotIndicator = ({ fill }: { fill?: string | null }) => {
  const fillColor = fill || 'var(--mui-palette-background-black1)';

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <circle cx='12' cy='12' r='5' stroke={fillColor} strokeWidth='2' />
    </svg>
  );
};

const FullSnapshotIndicator = styled('div')(
  (props: { backgroundColor: string | null; sx?: object }) => ({
    height: '12px',
    width: '12px',
    borderRadius: '50%',
    display: 'inline-block',
    minWidth: '12px',
    minHeight: '12px',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: props.backgroundColor || 'gray',
    backgroundColor: props.backgroundColor || 'transparent',
    ...props.sx,
  })
);

const PartialSnapshotIndicator = (props: {
  backgroundColor: string | null;
  sx?: object;
}) => {
  return (
    <Box
      sx={{
        height: '12px',
        width: '12px',
        borderRadius: '50%',
        display: 'inline-block',
        minWidth: '12px',
        minHeight: '12px',
        border: `2px solid ${props.backgroundColor}`,
        overflow: 'hidden',
        ...props.sx,
      }}
    >
      <Box
        sx={{
          marginTop: '-1.5px',
          marginLeft: '-3px',
          height: '5px',
          width: '12px',
          transform: 'rotate(-45deg)',
          backgroundColor: props.backgroundColor,
        }}
      ></Box>
    </Box>
  );
};
